import { memo, SVGProps } from 'react';

function CloseIcon(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props} data-testid="closeIcon">
      <path
        stroke={props?.stroke ? props.stroke : '#0D0D0D'}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m5.5 18.5 13-13m0 13-13-13"
      />
    </svg>
  );
}

export function CloseIcon2x(props?: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={19}
      height={19}
      viewBox="0 0 19 19"
      fill="none"
      {...props}
      data-testid="closeIcon2x"
    >
      <path
        d="M17.4795 0.146447C17.6747 -0.0487614 17.9912 -0.0486531 18.1865 0.146447C18.3817 0.341709 18.3817 0.658216 18.1865 0.853478L9.87301 9.16598L18.1865 17.4795C18.3817 17.6747 18.3817 17.9912 18.1865 18.1865C17.9912 18.3817 17.6747 18.3817 17.4795 18.1865L9.16598 9.87301L0.853478 18.1865C0.658216 18.3817 0.341709 18.3817 0.146447 18.1865C-0.0486531 17.9912 -0.0487614 17.6747 0.146447 17.4795L8.45895 9.16598L0.146447 0.853478C-0.0488155 0.658216 -0.0488156 0.341709 0.146447 0.146447C0.341709 -0.0488156 0.658216 -0.0488155 0.853478 0.146447L9.16598 8.45895L17.4795 0.146447Z"
        fill="black"
      />
    </svg>
  );
}

export default memo(CloseIcon);
